import router from '@/router/index2'
import NProgress from 'nprogress' 
import 'nprogress/nprogress.css' 
import { getAccessToken } from './utils/auth'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/404', '/not-permission', '/homepage', '/token', '/pricing', '/forbidden', '/logout' ]
router.beforeEach(async(to, from, next) => {
  NProgress.start()
  const hasToken = getAccessToken()
  if (hasToken) {
    if (to.path === '/homepage' || to.path === '/') {
      next({ path: '/dashboard' })
      NProgress.done()
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/homepage`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
